import './App.scss';
import '../../styles/type.scss';
import Footer from '../Footer/footer';
import NotFound from '../NotFound/notfound';
import Home from "../Home/home";
import PortfolioPage from "../PortfolioPage/PortfolioPage";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

function App() {
  return (
      <>
       
        <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<PortfolioPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Router>
        <Footer />
      </>
  );
}

export default App;